import * as DM from '@radix-ui/react-dropdown-menu';
import { Printer } from 'lucide-react';
import type { ReportRef } from '@/lib/types';
import { useWorkspace } from '@/shell/workspace';

/**
 * Forma bağlı raporlar (Delphi YazdirPopup: dm.Rapor OZEL_KOD ⊃ form başlığı).
 * Seçili kayıttan parametre ön doldurma Delphi MenuItemClick ile aynı: ID/Kayıt No, Evrak No, Cari Kodu, Cari Ünvanı, Tarih.
 */
export function ReportMenu({ reports, row, params: extra, beforeOpen, label }: { reports: ReportRef[]; row: Record<string, any> | null; params?: Record<string, unknown>; beforeOpen?: () => Promise<boolean>; label?: string }) {
  const ws = useWorkspace();
  if (!reports.length) return null;
  const open = async (r: ReportRef) => {
    // Delphi YazdirPopup (Form80_3/80_4): rapordan önce kayıt yapılır
    if (beforeOpen && !(await beforeOpen())) return;
    const params: Record<string, unknown> = {};
    if (row) {
      const g = (k: string) => row[k] ?? row[Object.keys(row).find((x) => x.toUpperCase() === k) ?? ''];
      params['ID'] = g('ID'); params['Kayıt No'] = g('ID');
      params['Evrak No'] = g('EVRAK_NO'); params['Cari Kodu'] = g('CARI_KODU'); params['Cari Ünvanı'] = g('CARI_UNVAN'); params['Tarih'] = g('TARIH');
      Object.assign(params, extra ?? {});
      for (const k of Object.keys(params)) if (params[k] == null) delete params[k];
    }
    ws.open({ kind: 'report', title: r.name, reportId: r.id, props: { params, fromForm: true } }, { newInstance: true });
  };
  return (
    <DM.Root>
      <DM.Trigger className="btn"><Printer size={14} /> {label ?? 'Yazdır'}</DM.Trigger>
      <DM.Portal>
        <DM.Content align="end" className="panel z-50 max-h-96 min-w-56 overflow-auto rounded p-1 shadow-lg scroll-thin">
          {reports.map((r) => (
            <DM.Item key={r.id} className="cursor-pointer rounded px-2 py-1.5 text-[12.5px] outline-none hover:bg-[var(--grid-header)]" onSelect={() => open(r)}>{r.name}</DM.Item>
          ))}
        </DM.Content>
      </DM.Portal>
    </DM.Root>
  );
}
